import { useSelector, useDispatch } from 'react-redux';
import FJVideoRemoveBgCustomExport from '../view/FJVideoRemoveBgCustomExport';
import { useCallback } from 'react';
import FJActionVideoRemoveBg from '../../../../redux/action/FJActionVideoRemoveBg';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';
import { FJVideoRemoveBgDataConfig } from '../../../../config/dataConfig/FJVideoRemoveBgDataConfig.js';
import {
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS,
    DEFAULT_FILE_TYPES,
} from '../../../../config/dataConfig/FJGenerateData.js';

const FJVideoRemoveBgCustomExportContainer = () => {
    const dispatch = useDispatch();
    const status = useSelector(state => state.videoBgRemover.customExportData.exportStatus);
    const progress = useSelector(state => state.videoBgRemover.customExportData.exportProgress);
    const isApplyButton = useSelector(state => state.common.isApplyButton);

    const download = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.exportVideoAction());
    }, [dispatch]);

    const cancelExport = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.cancelExportVideoAction());
    }, [dispatch]);

    const removeMore = useCallback(
        file => {
            dispatch(FJActionVideoRemoveBg.uploadCustomVideoAction(file));
        },
        [dispatch],
    );

    const _onEdit = () => {
        dispatch(FJActionVideoRemoveBg.onEditAction());
    };

    const _onClick = () => {
        dispatch(
            FJActionEditPage.openMediaLibraryAction({
                uploadConfig: {
                    isMultiple: false,
                    maxMediaNum: 1,
                    selectedMediaIds: [],
                    acceptTypeWithTranscode:
                        FJVideoRemoveBgDataConfig.ACCEPT_FILE_TYPE + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS,
                    acceptTypeNoTranscode: [
                        ...FJVideoRemoveBgDataConfig.SUPPORTED_VIDEO_FORMATS,
                        ...DEFAULT_FILE_TYPES,
                    ],
                    suffixTranscode: CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS,
                    // 媒体库的过滤规则
                    mediaFilterFunc: item => {
                        const mediaTypes = ['VIDEO'];
                        return mediaTypes.includes(item.type);
                    },
                    // 上传文件之后返回的数据
                    callbackOptions: {},
                },
            }),
        );
    };

    return (
        <FJVideoRemoveBgCustomExport
            status={status}
            progress={progress}
            download={download}
            goToBack={cancelExport}
            removeMore={removeMore}
            cancelExport={cancelExport}
            isCustom={true}
            onEdit={_onEdit}
            onClick={_onClick}
            isApplyButton={isApplyButton}
        />
    );
};

export default FJVideoRemoveBgCustomExportContainer;
